export default "__VITE_ASSET__DaU1RNOZ__"